import { CURRENT_COLOR } from 'src/config';
import { IconsTypesProps } from '../types';

export const CheckmarkCircleFilledIcon = ({ fill }: IconsTypesProps) => {
  const color = fill ?? CURRENT_COLOR;

  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.333313 7.00004C0.333313 3.31814 3.31808 0.333374 6.99998 0.333374C8.76809 0.333374 10.4638 1.03575 11.714 2.286C12.9643 3.53624 13.6666 5.23193 13.6666 7.00004C13.6666 10.6819 10.6819 13.6667 6.99998 13.6667C3.31808 13.6667 0.333313 10.6819 0.333313 7.00004ZM6.81998 9.40671L9.86665 5.40671V5.38671C10.0119 5.19617 10.0445 4.94259 9.95216 4.72149C9.85979 4.5004 9.65649 4.34538 9.41883 4.31483C9.18117 4.28427 8.94527 4.38283 8.79998 4.57337L6.27998 7.90671L5.19331 6.52004C5.04683 6.33188 4.8111 6.23616 4.57491 6.26893C4.33872 6.30171 4.13795 6.458 4.04824 6.67893C3.95853 6.89987 3.9935 7.15188 4.13998 7.34004L5.76665 9.41337C5.89386 9.57437 6.08813 9.66781 6.29331 9.66671C6.49964 9.66621 6.69412 9.57021 6.81998 9.40671Z"
        fill={color}
      />
    </svg>
  );
};
